import {
  NEXT_STEP,
  FINISH_SETP,
  PREVIOUS_SETP,
  SET_TOKEN,
  SET_SEPT_INFO
} from './data'
import {
  getToken,
  getApplicationId,
  setToken,
  setApplicationId,
  removeToken,
  removeApplicationId
} from '@/utils/auth'
import {
  Session
} from '@/assets/js/storage'
const state = {
  token: getToken(),
  applicationId: getApplicationId(),
  //當前步骤信息狀態
  setepInfo: {
    currentStepName: 'apply', //当前步骤名称
    currentStepNum: 0, //步骤，默认为1
    currentOperateName: 'home', //当前操作名称
  }
};


const mutations = {

  /**
   * 上一步操作
   * @param {*} state 
   * @param {*} changeStep 步骤条是否发生改变
   * @param {*} operateName 当前操作表单名称
   */
  [PREVIOUS_SETP](state, operate) {
    if (operate.changeStep) {
      state.setepInfo.currentStepNum--;
      Session.set("currentStepNum", state.setepInfo.currentStepNum)
    }
    state.setepInfo.currentOperateName = operate.operateName;
    Session.set("setepInfo", state.setepInfo)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // 可选，平滑滚动 auto  smooth
    });
  },

  /**
   * 下一步操作
   * @param {} state 
   * @param {*} operate 
   */
  [NEXT_STEP](state, operate) {
    if (operate.changeStep) {
      state.setepInfo.currentStepNum++;
      Session.set("currentStepNum", state.setepInfo.currentStepNum)
    }
    state.setepInfo.currentOperateName = operate.operateName;
    Session.set("setepInfo", state.setepInfo)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // 可选，平滑滚动 auto  smooth
    });
  },

  /**
   * 完成申请信息
   * @param {*} state 
   */
  [FINISH_SETP](state) {
    Session.remove('currentStepNum')
    state.setepInfo.currentStepName = 'apply';
    state.setepInfo.currentStepNum = 0;
    state.setepInfo.currentOperateName = 'home';
    Session.set("setepInfo", state.setepInfo)
    //清除瀏覽器緩存
    Session.remove("queryParams")
    Session.remove("queryResult")
    Session.remove("formId")
    Session.remove("formName")
    Session.remove("personalInfo")
    Session.remove("hleFormData")
    Session.remove("hleFormData2")
    Session.remove("eligibilityDeclaration")
    Session.remove("fileUploadForm")
    Session.remove("fileUploadForm2")
    Session.remove("declaretionCondition")
    Session.remove("verifyEmail")
    Session.remove("applyCode")
    removeToken()
    removeApplicationId()

  },

  [SET_TOKEN](state, token) {
    state.token = token.token
    state.applicationId = token.id
    setApplicationId(state.applicationId)
    setToken(state.token)
  },
  /**
   * 修改步骤信息
   * @param {*} state 
   * @param {*} info 
   */
  [SET_SEPT_INFO](state, info) {
    state.setepInfo[info.k] = info.v
    Session.set("setepInfo", state.setepInfo)
  },

};

const getters = {

  querySetepInfo(state) {
    var setepInfo = Session.get("setepInfo")
    if (setepInfo) { //如果缓存有值 丢给store
      state.setepInfo = setepInfo
    } else {
      setepInfo = state.setepInfo
    }
    Session.set("setepInfo", setepInfo)
    return setepInfo
  },

};

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/mutations.js